import { tagsView } from '@/store';
import pageOpen from './pageOpen';

function pageClose(fullPath: string, func?: () => void) {
  const view = tagsView.views.find(v => v.fullPath === fullPath);
  if (view) {
    tagsView.delView(view).then((views) => {
      if (func) {
        func();
      } else {
        const latestView = views.slice(-1)[0];
        if (latestView) {
          pageOpen(latestView.fullPath || '/');
        } else {
          pageOpen('/');
        }
      }
    });
  }
}

export default pageClose;
